import React from 'react';
import { Status } from '../../../../atoms/Status/Status';
import { Text } from '../../../../atoms/Text/Text';
const baseClass = 'qmb-ui-integration-sync-status-panel__audit-history';
const OUTCOME_COLORS = new Map([
    ['enqueued', 'green-500'],
    ['blocked_repeat_limit', 'yellow-500'],
    ['field_write_failed', 'red-500'],
    ['enqueue_failed', 'red-500']
]);
export function AuditHistoryList({ auditHistory, labels }) {
    return (React.createElement("div", { className: baseClass },
        React.createElement(Text, { variant: "small", as: "h3" }, labels.auditHeading),
        auditHistory.length === 0 ? (React.createElement(Text, { variant: "body", as: "p" }, labels.emptyAuditMessage)) : (React.createElement("ul", { className: `${baseClass}__list` }, auditHistory.map((entry) => (React.createElement("li", { key: entry.id, className: `${baseClass}__row` },
            React.createElement(Status, { label: labels.outcomeLabels[entry.outcome], color: OUTCOME_COLORS.get(entry.outcome) }),
            React.createElement(Text, { variant: "body", as: "span" }, entry.triggeredByIdentifier),
            React.createElement(Text, { variant: "x-small", as: "span", className: `${baseClass}__timestamp` }, entry.createdAt),
            React.createElement(Text, { variant: "body", as: "p", className: `${baseClass}__reason` }, entry.reason))))))));
}
export default AuditHistoryList;
